import { render, staticRenderFns } from "./BookingHeader.vue?vue&type=template&id=d58b252e&scoped=true"
import script from "./BookingHeader.vue?vue&type=script&lang=js"
export * from "./BookingHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58b252e",
  null
  
)

export default component.exports